import { NotificationManager } from "react-notifications";
import apiURL from "./apiURL";
// const apiURL = "http://localhost:3000"

// const orgId = window.location.pathname == '/xero/callback/' ? window.localStorage.getItem('organisation') : window.location.pathname.split('/')[2];
// types of action
const Types = {
	PAYPERIOD_UPDATING: "PAYPERIOD_UPDATING",
	PAYPERIOD_UPDATE: "PAYPERIOD_UPDATE",
	PAYPERIOD_DOWNLOADING: "PAYPERIOD_DOWNLOADING",
	PAYPERIOD_UPDATE_SINGLE: "PAYPERIOD_UPDATE_SINGLE",
	PAYPERIOD_SET_HMRC_ERRORS_MODAL: "PAYPERIOD_SET_HMRC_ERRORS_MODAL",
};

const payPeriodsUpdating = () => ({
	type: Types.PAYPERIOD_UPDATING,
});

const payPeriodsUpdated = (response) => ({
	type: Types.PAYPERIOD_UPDATE,
	payload: response,
});

const getPayPeriods = () => {
	return (dispatch, getState) => {
		dispatch(payPeriodsUpdating());
		fetch(apiURL + `/settings/payPeriods`, {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				/*'Organisation': getState().currentOrganisation,*/
			},
		})
			.then((response) => response.json())
			.then((data) => {
				console.log("entity data", data);
				dispatch(payPeriodsUpdated(data));
			});
	};
};

const deletePayPeriod = ({ payScheduleId }) => {
	return (dispatch, getState) => {
		const state = getState();
		const periods = state?.payPeriods?.periods?.filter((p) => p.paySchedule === payScheduleId) || [];
		if (!periods.length || periods.length > 1) return;
		fetch(apiURL + `/settings/payPeriod/${periods[0].id}`, {
			credentials: "include",
			method: "DELETE",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				/*'Organisation': getState().currentOrganisation,*/
			},
		})
			.then((response) => response.json())
			.then(() => {
				// console.log("deleted", payScheduleId, periods[0].id);
			});
	};
};

const updatePayPeriod = (response) => ({
	type: Types.PAYPERIOD_UPDATE_SINGLE,
	response,
});

const getHMRCSubmissionStatus = (payPeriodId) => {
	return async (dispatch, getState) => {
		await fetch(apiURL + `/settings/submission-status/${payPeriodId}`, {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch(updatePayPeriod(data));
				console.debug(`${payPeriodId} - Response: ${data.submissionStatus}`);
				if (data.submissionStatus === "Success") {
					NotificationManager.success("Successfully Submitted FPS to HMRC!", "Submitting FPS to HMRC");
				}
				if (data.submissionStatus === "error") {
					NotificationManager.error("Error Submitting FPS to HMRC.", "Submitting FPS to HMRC");
				}
			});
	};
};

const downloadStatus = (id, type, processing) => ({
	type: Types.PAYPERIOD_DOWNLOADING,
	id,
	type,
	processing,
});

const download = (id, type) => {
	return (dispatch, getState) => {
		dispatch(downloadStatus(id, type, true));

		fetch(apiURL + `/settings/payslip/${id}/download`, {
			credentials: "include",
			method: "GET",
			// body: JSON.stringify(body),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				/*'Organisation': getState().currentOrganisation,*/
			},
		})
			.then((response) => response.json())
			.then((data) => {
				const popup = window.open(data.signedURL);
				if (!popup || popup.closed || typeof popup.closed == "undefined") {
					//Worked For IE and Firefox
					alert("Popup Blocker is enabled! Please add this site to your exception list.");
				}

				dispatch(downloadStatus(id, type, false));
			});
	};
};

const setHMRCErrorsModal = ({ open, period }) => ({
	type: Types.PAYPERIOD_SET_HMRC_ERRORS_MODAL,
	open,
	period,
});

const Actions = {
	getPayPeriods,
	download,
	getHMRCSubmissionStatus,
	deletePayPeriod,
	setHMRCErrorsModal,
};

// exports = {
//   Types,
//   Actions
// }

export { Types, Actions };

// exports.Types = Types
// exports.Actions = Actions
